/**
 * @fileoverview This file was generated by the Angular template compiler. Do not edit.
 *
 * @suppress {suspiciousCode,uselessCode,missingProperties,missingOverride,checkTypes}
 * tslint:disable
 */ 
var styles = ["[_nghost-%COMP%]{display:flex;flex-direction:column;flex:1 1 auto}cdk-virtual-scroll-viewport[_ngcontent-%COMP%]{flex:1 1 auto}"];
export { styles as styles };
